<template>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Proformas</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">Detalle</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12 border-2">
    <div
      class="flex align-items-center flex-column lg:justify-content-center lg:flex-row mb-4"
    >
      <h2>
        <strong>PROFORMA # {{ proforma.numero }}</strong>
      </h2>
    </div>
    <div class="grid border-bottom-3" style="background-color: #f8f9fa">
      <div class="col-6">
        <p class="mb-0">
          <strong>NRO. PROFORMA: </strong> <span>{{ proforma.numero }}</span>
        </p>
        <p class="mb-0">
          <strong>CLIENTE: </strong>
          <span>{{ proforma.cliente }}</span>
        </p>
        <p class="mb-0">
          <strong>V&Aacute;LIDO HASTA: </strong>
          <span>{{ proforma.valido_hasta ?? "No definido" }}</span>
        </p>
      </div>
      <div class="col-6">
        <p class="mb-0">
          <strong>FECHA DE REGISTRO: </strong>
          <span>{{ proforma.fecha }}</span>
        </p>

        <p class="mb-0">
          <strong>USUARIO: </strong>
          <span>{{ proforma.vendedor }}</span>
        </p>
      </div>
    </div>
    <div class="grid mt-4">
      <DataTable ref="ventas" :value="productos" class="col-12">
        <Column field="codigo_interno" header="CODIGO INTERNO">
          {{ producto.codigo_interno }}
        </Column>
        <Column field="descripcion" header="DESCRIPCION">
          {{ producto.descripcion }}
        </Column>
        <Column
          field="pivot.precio"
          header="PRECIO UNITARIO"
          class="text-right"
        >
          <template #body="slotProps">
            {{ convertirNumeroGermanicFormat(slotProps.data.pivot.precio) }}
          </template>
        </Column>
        <Column field="pivot.cantidad" header="CANTIDAD" class="text-right">
          <template #body="slotProps">
            {{ convertirNumeroGermanicFormat(slotProps.data.pivot.cantidad) }}
          </template>
        </Column>
        <Column field="pivot.nro_dias" header="DIAS" class="text-right">
          {{ producto.pivot.nro_dias }}
        </Column>
        <Column header="TOTAL" class="text-right">
          <template #body="slotProps">
            {{ convertirNumeroGermanicFormat(slotProps.data.pivot.subtotal) }}
          </template>
        </Column>
        <template #footer>
          <!-- <div class="text-lg flex align-items-end justify-content-end">
            <h5>
              <strong>SUBTOTAL Bs:</strong>
              {{ convertirNumeroGermanicFormat(subtotal) }}
            </h5>
          </div> -->
          <!-- <div class="text-lg flex align-items-end justify-content-end">
            <h5>
              <strong>DESCUENTO Bs:</strong>
              {{ convertirNumeroGermanicFormat(venta.descuento) }}
            </h5>
          </div> -->
          <div class="text-lg flex align-items-end justify-content-end">
            <h5>
              <strong>TOTAL PROFORMA Bs :</strong>
              {{ convertirNumeroGermanicFormat(proforma.total) }}
            </h5>
          </div>
        </template>
      </DataTable>
    </div>
    <div class="grid mt-4">
      <div class="col-12 border-top-1 pt-3">
        <p class="text-900 font-bold mb-2">OBSERVACIONES:</p>
        <p class="text-700">
          {{ proforma.observaciones || "No hay observaciones" }}
        </p>
      </div>
    </div>
    <div class="grid mt-2 justify-content-end">
      <Button @click="goBack" class="p-button-lg p-button-primary">
        <i class="pi pi-arrow-circle-left mr-1"></i>
        &nbsp;Atr&aacute;s
      </Button>
      <Button
        label="Imprimir"
        icon="pi pi-file-pdf"
        class="p-button-danger ml-2 p-button-lg"
        v-tooltip.top="'Imprimir PDF (servidor)'"
        @click="imprimirVenta(proforma.id)"
        :disabled="imprimiendo"
        :loading="imprimiendo"
      />
      <Button
        label="Descargar PDF"
        icon="pi pi-download"
        class="p-button-success ml-2 p-button-lg"
        v-tooltip.top="'Descargar PDF (vista actual)'"
        @click="descargarPdfLocal"
      />
    </div>
    <!-- Modal para previsualizar y descargar PDF local -->
    <Dialog
      v-model:visible="showPdfDialog"
      :modal="true"
      header="Descargar PDF"
      :style="{
        width: '100vw',
        maxWidth: '100vw',
        minWidth: '320px',
        top: '0',
        left: '0',
        margin: '0',
        padding: '0',
        zIndex: 1200,
      }"
      :contentStyle="{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '0',
        minHeight: '100vh',
        maxHeight: '100vh',
        background: '#f4f4f4',
        zIndex: 1201,
        overflowY: 'auto'
      }"
      :closable="true"
      :dismissableMask="true"
      :draggable="false"
      :blockScroll="true"
      :breakpoints="{ '960px': '98vw', '640px': '100vw' }"
      :baseZIndex="1200"
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
        "
      >
        <!-- Botones SIEMPRE arriba de la previsualización -->
        <div
          style="
            display: flex;
            justify-content: flex-end;
            margin-bottom: 10px;
            width: 100%;
            max-width: 820px;
            margin-left: auto;
            margin-right: auto;
            position: relative;
            z-index: 2000;
          "
        >
          <Button
            label="Descargar PDF"
            icon="pi pi-download"
            class="p-button-success pdf-download-btn"
            @click="generarYDescargarPdf"
            :disabled="pdfLoading"
            style="z-index: 2001; position: relative"
          />
          <Button
            label="Cerrar"
            icon="pi pi-times"
            class="p-button-text ml-2"
            @click="showPdfDialog = false"
            style="z-index: 2001; position: relative"
          />
        </div>
        <!-- Previsualización PDF SIN restricciones de alto ni overflow -->
        <div style="width: 100%; display: flex; justify-content: center;">
          <div
            ref="previsualizacionPdf"
            style="
              background: #fff;
              box-shadow: none;
              width: 100%;
              max-width: 800px;
              margin: 0 auto;
              padding: 24px 18px;
              min-width: 700px;
            "
          >
            <ProformaPdf :proforma="proforma" />
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import ProformaService from "@/service/ProformaService";
import VentaService from "@/service/VentaService";
import ProformaPdf from "./ProformaPdf.vue";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  data() {
    return {
      proforma: {},
      productos: [],
      proforma_id: this.$route.params.id,
      imprimiendo: false,
      showPdfDialog: false,
      pdfLoading: false,
    };
  },
  components: {
    ProformaPdf,
  },
  proformaService: null,
  ventaService: null,
  created() {
    this.proformaService = new ProformaService();
    this.ventaService = new VentaService();
  },
  mounted() {
    this.cargarProforma();
  },
  computed: {
    subtotal() {
      let subtotal = 0;
      this.productos.forEach((producto) => {
        subtotal += producto.pivot.precio * producto.pivot.cantidad;
      });
      return subtotal;
    },
  },
  methods: {
    cargarProforma() {
      this.proformaService.buscarProforma(this.proforma_id).then((response) => {
        this.proforma = response.proforma || {};
        this.productos = response.proforma.detalles || [];
      });
    },
    imprimirVenta(id) {
      if (this.imprimiendo) {
        return;
      }
      this.imprimiendo = true;
      this.ventaService.imprimirVentaProforma(id).then(() => {
        this.imprimiendo = false;
      });
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
      }).format(numero);
    },
    goBack() {
      this.$router.go(-1);
    },
    async descargarPdfLocal() {
      this.showPdfDialog = true;
      this.pdfLoading = false;
      await this.$nextTick();
      // Forzar el foco en el botón de descargar PDF del modal (solo el del modal)
      const btn = document.querySelector(".pdf-download-btn");
      if (btn) btn.focus();
    },
    async generarYDescargarPdf() {
      this.pdfLoading = true;
      try {
        await this.$nextTick();
        const element = this.$refs.previsualizacionPdf;
        if (!element) {
          alert("No se encontró el contenido para exportar.");
          this.pdfLoading = false;
          return;
        }
        // Usar html2canvas para capturar el contenido
        const canvas = await html2canvas(element, { scale: 2, useCORS: true });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "pt",
          format: "a4",
        });
        // Calcular tamaño para A4
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = pageWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let position = 0;
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        // Si el contenido es más largo que una página, agregar páginas
        let remainingHeight = imgHeight;
        while (remainingHeight > pageHeight) {
          position = position - pageHeight;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          remainingHeight -= pageHeight;
        }
        pdf.save("proforma_detalle.pdf");
        this.showPdfDialog = false;
      } catch (error) {
        console.error("Error al generar el PDF:", error);
        alert("Error al generar el PDF.");
      }
      this.pdfLoading = false;
    },
  },
};
</script>
